<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>旗下公司</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="名称" min-width="15%"></el-table-column>
          <el-table-column prop="Info" label="简介" min-width="18%"></el-table-column>
          <el-table-column prop="Pic1" label="缩略图:列表左侧" min-width="25%"></el-table-column>
          <el-table-column prop="Pic2" label="缩略图:详情右侧" min-width="25%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="12%"></el-table-column>
          <el-table-column label="操作" min-width="5%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteSubsidiaryCompanyEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteSubsidiaryCompanyEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteSubsidiaryCompanyEdit from '@/componentsKgjt/KgjtWebsiteSubsidiaryCompanyEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteSubsidiaryCompanyEdit
  },
  name: 'MyKgjtWebsiteSubsidiaryCompany',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        name: ''
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteSubsidiaryCompanyNum()
    this.GetKgjtWebsiteSubsidiaryCompanyList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteSubsidiaryCompanyList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteSubsidiaryCompanyList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteSubsidiaryCompanyNum()
      this.GetKgjtWebsiteSubsidiaryCompanyList()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    GetKgjtWebsiteSubsidiaryCompanyList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteSubsidiaryCompanyList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteSubsidiaryCompanyNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteSubsidiaryCompanyNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
